import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { GetCookie } from '../utils/cookies';

const SubscriptionContext = createContext({
  aiproUser: {
    plan_name: '',
    subscription_start: { date: '' },
    subscription_end: { date: '' }
  },
  loading: false,
  subscriptionData: [],
});

export function SubscriptionProvider({ value, children }) {
  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
}

export function useSubscription() {
  const contextValue = useContext(SubscriptionContext);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSubscriptions = useCallback(async () => {
    const tk = GetCookie('access');
    if (!tk) {
      setSubscriptionData([]);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/get-subscription`,
        { tk: tk || '' },
        { headers: { 'content-type': 'application/x-www-form-urlencoded' } }
      );
      
      if (response.data?.success && Array.isArray(response.data.data)) {
        setSubscriptionData(response.data.data);
      } else {
        setSubscriptionData([]);
      }
    } catch (e) {
      console.error('get-subscription error:', e);
      setSubscriptionData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSubscriptions();
  }, [fetchSubscriptions]);

  return {
    ...contextValue,
    subscriptionData,
    loading: loading || contextValue.loading,
  };
}